export default __webpack_public_path__ + "static/juanDiego-c95bfd9f94fb52eba1473a22bef18f88.png";